import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

interface IErrorMessageWithLabelProps {
	resourcesError: string,
	label: string,
}

const useStyles = makeStyles((theme) =>
	createStyles({
		subRowHeader: {
			fontWeight: 'bold',
			marginBottom: '7px',
		},
	}),
);

export function ErrorMessageWithLabel(props: IErrorMessageWithLabelProps) {
	const { t } = useTranslation();
	return <p className="text-danger">
		{t(props.resourcesError, { label: props.label })}
	</p>
}

export function SubRowHeader(props: React.PropsWithChildren<{}>) {
	const classes = useStyles();
	return <div className={clsx("text-strong sub-input-row-header", classes.subRowHeader)}>
		{props.children}
	</div>
}